import React from 'react';
import { useDispatch } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { Formik, FormikHelpers } from 'formik';

import { useIsRequired } from '@hooks/yup';

import CorporateHealthQuoteBuyForm, { FormRequired, FormValues } from '../CorporateHealthQuoteBuyForm';
import { corporateHealthQuoteCreate, CorporateHealthQuoteCreatePayload } from '../action';
import { useInitialValues, useValidationSchema } from './hook';

const CorporateHealthQuoteBuyNewPage = () => {
  const dispatch = useDispatch();
  const initialValues = useInitialValues();
  const validationSchema = useValidationSchema();
  const required = useIsRequired<FormRequired>(validationSchema);

  const handleSubmit = (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    const payload: CorporateHealthQuoteCreatePayload = values
    dispatch(corporateHealthQuoteCreate(payload));
    setSubmitting(false);
  };

  return (
    <Container className="my-3">
      <Row className="gy-5">
        <Col lg={8}>
          <Formik validationSchema={validationSchema} initialValues={initialValues} onSubmit={handleSubmit}>
            <CorporateHealthQuoteBuyForm required={required} />
          </Formik>
        </Col>
      </Row>
    </Container>
  );
};

export { CorporateHealthQuoteBuyNewPage };
